import { Slice } from 'prosemirror-model';
import { EditorView } from 'prosemirror-view';

// https://github.com/ckeditor/ckeditor5/blob/a127c97/packages/ckeditor5-paste-from-office/src/filters/image.js
export const extractImageDataFromRtf = (rtfData: string | null) => {
  if (!rtfData) {
    return [];
  }

  const regexPictureHeader =
    /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/;
  const regexPicture = new RegExp(
    '(?:(' + regexPictureHeader.source + '))([\\da-fA-F\\s]+)\\}',
    'g',
  );
  const images = rtfData.match(regexPicture);
  const result = [];

  if (images) {
    for (const image of images) {
      let imageType = '';

      if (image.includes('\\pngblip')) {
        imageType = 'image/png';
      } else if (image.includes('\\jpegblip')) {
        imageType = 'image/jpeg';
      }

      if (imageType) {
        result.push({
          hex: image.replace(regexPictureHeader, '').replace(/[^\da-fA-F]/g, ''),
          type: imageType,
        });
      }
    }
  }

  return result;
};

export const convertHexToBase64 = (hexString: any) => {
  return btoa(
    hexString
      .match(/\w{2}/g)
      .map((char: any) => {
        return String.fromCharCode(parseInt(char, 16));
      })
      .join(''),
  );
};

// ref: https://github.com/ProseMirror/prosemirror-view/blob/180050a407d9b930e7d360e8cf1faf6a849661c9/src/input.js#L546
export const dispatchPasteEvent = (view: EditorView, slice: Slice) => {
  let singleNode = sliceSingleNode(slice);
  let tr = singleNode
    ? view.state.tr.replaceSelectionWith(singleNode, (view as any).shiftKey)
    : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta('paste', true).setMeta('uiEvent', 'paste'));
};

const sliceSingleNode = (slice: Slice) => {
  return slice.openStart === 0 && slice.openEnd === 0 && slice.content.childCount === 1
    ? slice.content.firstChild
    : null;
};
